module.exports = __webpack_public_path__ + "img/chat.885a5bf5.png";